import {
  ChangeDetectionStrategy,
  Component,
  booleanAttribute,
  computed,
  input,
  output,
} from '@angular/core';

@Component({
  selector: 'app-text-button',
  standalone: true,
  templateUrl: './text-button.component.html',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class TextButtonComponent {
  label = input.required<string>();
  loading = input(false, { transform: booleanAttribute });
  disabled = input(false, { transform: booleanAttribute });
  styleClass = input<string>();

  private readonly classesBase =
    'inline-flex items-center gap-1 p-0 m-0 border-0 bg-transparent text-[11px] font-medium leading-none text-bluegray-500 underline hover:text-bluegray-800 hover:underline disabled:opacity-50 disabled:cursor-not-allowed disabled:hover:no-underline';

  buttonClass = computed(() => {
    const extra = this.styleClass();
    return [this.classesBase, extra].filter(Boolean).join(' ');
  });

  estaDesabilitado = computed(() => this.disabled() || this.loading());

  handleClick = output<MouseEvent>();
}
